import React from "react";

const TicketMobile = ({}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="53.621"
      height="38"
      viewBox="0 0 53.621 38"
    >
      <g
        id="Raggruppa_1190"
        data-name="Raggruppa 1190"
        transform="translate(-35.379 -573)"
      >
        <g
          id="Raggruppa_926"
          data-name="Raggruppa 926"
          transform="translate(106.94 1237) rotate(180)"
        >
          <path
            id="Tracciato_258"
            data-name="Tracciato 258"
            d="M0,0,4.24,4.241,0,8.482"
            transform="translate(64.5 650.741) rotate(180)"
            fill="none"
            stroke="#303130"
            stroke-linecap="round"
            stroke-width="1.5"
          />
          <path
            id="Tracciato_259"
            data-name="Tracciato 259"
            d="M0,0,4.24,4.241,0,8.482"
            transform="translate(70.5 650.741) rotate(180)"
            fill="none"
            stroke="#303130"
            stroke-linecap="round"
            stroke-width="1.5"
          />
        </g>
        <g
          id="Raggruppa_1040"
          data-name="Raggruppa 1040"
          transform="translate(0 57)"
        >
          <g
            id="Raggruppa_1037"
            data-name="Raggruppa 1037"
            transform="translate(-27 -57)"
          >
            <rect
              id="Rettangolo_536"
              data-name="Rettangolo 536"
              width="18"
              height="34"
              rx="2"
              transform="translate(98 575)"
              fill="#303130"
            />
            <path
              id="Tracciato_277"
              data-name="Tracciato 277"
              d="M2493.355,8559.485h4.972"
              transform="translate(-2388.855 -7978.205)"
              fill="#fbfbfb"
              stroke="#fff"
              stroke-linecap="round"
              stroke-width="2"
            />
            <path
              id="Tracciato_278"
              data-name="Tracciato 278"
              d="M2493.355,8559.485h4.972"
              transform="translate(-2388.855 -7974.234)"
              fill="none"
              stroke="#fff"
              stroke-linecap="round"
              stroke-width="2"
            />
            <path
              id="Tracciato_279"
              data-name="Tracciato 279"
              d="M2493.355,8559.485h4.972"
              transform="translate(-2388.855 -7968.94)"
              fill="none"
              stroke="#fff"
              stroke-linecap="round"
              stroke-width="2"
            />
            <text
              id="_"
              data-name="€"
              transform="translate(104 603.53)"
              fill="#fff"
              font-size="11"
              font-family="HelveticaNeue-Bold, Helvetica Neue"
              font-weight="700"
              letter-spacing="0.009em"
            >
              <tspan x="0" y="0">
                €
              </tspan>
            </text>
          </g>
          <g id="Raggruppa_1038" data-name="Raggruppa 1038">
            <g
              id="Ellisse_47"
              data-name="Ellisse 47"
              transform="translate(73 516)"
              fill="#f3f3f3"
              stroke="#f3f3f3"
              stroke-width="1"
            >
              <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
              <circle cx="1.5" cy="1.5" r="1" fill="none" />
            </g>
            <g
              id="Ellisse_48"
              data-name="Ellisse 48"
              transform="translate(79 516)"
              fill="#f3f3f3"
              stroke="#f3f3f3"
              stroke-width="1"
            >
              <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
              <circle cx="1.5" cy="1.5" r="1" fill="none" />
            </g>
            <g
              id="Ellisse_49"
              data-name="Ellisse 49"
              transform="translate(85 516)"
              fill="#f3f3f3"
              stroke="#f3f3f3"
              stroke-width="1"
            >
              <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
              <circle cx="1.5" cy="1.5" r="1" fill="none" />
            </g>
          </g>
          <g
            id="Raggruppa_1039"
            data-name="Raggruppa 1039"
            transform="translate(0 35)"
          >
            <g
              id="Ellisse_47-2"
              data-name="Ellisse 47"
              transform="translate(73 516)"
              fill="#f3f3f3"
              stroke="#f3f3f3"
              stroke-width="1"
            >
              <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
              <circle cx="1.5" cy="1.5" r="1" fill="none" />
            </g>
            <g
              id="Ellisse_48-2"
              data-name="Ellisse 48"
              transform="translate(79 516)"
              fill="#f3f3f3"
              stroke="#f3f3f3"
              stroke-width="1"
            >
              <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
              <circle cx="1.5" cy="1.5" r="1" fill="none" />
            </g>
            <g
              id="Ellisse_49-2"
              data-name="Ellisse 49"
              transform="translate(85 516)"
              fill="#f3f3f3"
              stroke="#f3f3f3"
              stroke-width="1"
            >
              <circle cx="1.5" cy="1.5" r="1.5" stroke="none" />
              <circle cx="1.5" cy="1.5" r="1" fill="none" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TicketMobile;
